/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Renderer, RendererInterface } from "../Renderer";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "armor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "assets",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "celerity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getAugmented",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getBonusMod",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getGearName",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getGearType",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getRarity",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getVariation",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "health",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityColors",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToVariationMod",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "render",
    outputs: [
      {
        internalType: "string",
        name: "svg",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "weapons",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Renderer__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Renderer> {
    return super.deploy(overrides || {}) as Promise<Renderer>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Renderer {
    return super.attach(address) as Renderer;
  }
  connect(signer: Signer): Renderer__factory {
    return super.connect(signer) as Renderer__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RendererInterface {
    return new utils.Interface(_abi) as RendererInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Renderer {
    return new Contract(address, _abi, signerOrProvider) as Renderer;
  }
}
